import { Switch, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { useLanguage } from "../../../../stores/LanguageStore";
import { getDefaultHtmlCode } from "../modelUtils";
// import { getDefaultHtmlCode } from "chemin/vers/votre/util";

const HTMLSwitcher = ({ code, setCode, editorRef }) => {
  const lang = useLanguage((s) => s.language);

  return (
    <Switch
      label={lang.model_emails.html_editor}
      ml={"auto"}
      checked={code !== null}
      onChange={() => {
        if (code !== null) {
          // --- Passage de HTML vers Texte ---
          modals.openConfirmModal({
            title: lang.model_emails.html_switcher.warning_title,
            centered: true,
            children: (
              <Text size="sm">
                {lang.model_emails.html_switcher.html_to_text_warning}
              </Text>
            ),
            labels: {
              confirm: lang.model_emails.html_switcher.confirm,
              cancel: lang.model_emails.html_switcher.cancel,
            },
            confirmProps: { color: "red" },
            onConfirm: () => {
              setTimeout(() => {
                if (editorRef.current) {
                  editorRef.current.setContent(code, {
                    format: "raw",
                  });
                }
              }, 1000);
              setCode(null);
            },
          });
        } else {
          // --- Passage de Texte vers HTML ---
          modals.openConfirmModal({
            title: lang.model_emails.html_switcher.html_mode_title,
            centered: true,
            children: (
              <Text size="sm">
                {lang.model_emails.html_switcher.text_to_html_warning}
              </Text>
            ),
            labels: {
              confirm: lang.model_emails.html_switcher.confirm,
              cancel: lang.model_emails.html_switcher.cancel,
            },
            onConfirm: () => {
              // --- AJOUT DE getDefaultHtmlCode ICI ---
              if (editorRef.current) {
                const currentContent = editorRef.current.getContent();
                setCode(getDefaultHtmlCode(currentContent));
              } else {
                setCode(getDefaultHtmlCode("")); // Sécurité
              }
            },
          });
        }
      }}
    />
  );
};

export default HTMLSwitcher;
